import {
  SET_DASHBOARD,
  DASHBOARD_ITEM_SUMMARY_REQUEST,
  DASHBOARD_TOP_ITEMS_BY_CATEGORY_REQUEST,
  DASHBOARD_TOP_CATEGORIES_BY,
  DASHBOARD_TABLE_SUMMARY_REQUEST,
  DASHBOARD_LAZY_LOAD_PAGE_REQUEST,
  GET_DASHBOARD_REQUEST,
  DASHBOARD_CHANGE_OUTLET,
  DASHBOARD_CHANGE_DATE,
  DASHBOARD_SET_OUTLETS,
  DASHBOARD_PAGE_REQUEST,
} from './constants';

export function setDashboard(data) {
  return { type: SET_DASHBOARD, payload: { dashboard: data } };
}

export function setOutlets(outlets) {
  return { type: DASHBOARD_SET_OUTLETS, payload: { outlets } };
}

export function getDashboardRequest(query) {
  return { type: GET_DASHBOARD_REQUEST, payload: { query } };
}

export function changeOutlet(outletIds, startDate, endDate) {
  return {
    type: DASHBOARD_CHANGE_OUTLET,
    payload: { outletIds, startDate, endDate },
  };
}

export function changeDate(startDate, endDate, outlet) {
  return {
    type: DASHBOARD_CHANGE_DATE,
    payload: { startDate, endDate, outlet },
  };
}

export function pageRequest() {
  return { type: DASHBOARD_PAGE_REQUEST, payload: {} };
}

export function lazyLoadPageRequest() {
  return { type: DASHBOARD_LAZY_LOAD_PAGE_REQUEST, payload: {} };
}

export function itemSummaryRequest(startDate, endDate, outlet) {
  return {
    type: DASHBOARD_ITEM_SUMMARY_REQUEST,
    payload: { startDate, endDate, outlet },
  };
}

export function topCategoriesByRequest(startDate, endDate, outlet) {
  return {
    type: DASHBOARD_TOP_CATEGORIES_BY,
    payload: { startDate, endDate, outlet },
  };
}

export function topItemsByCategoryRequest(startDate, endDate, outlet) {
  return {
    type: DASHBOARD_TOP_ITEMS_BY_CATEGORY_REQUEST,
    payload: { startDate, endDate, outlet },
  };
}

export function tableSummaryRequest(startDate, endDate, outlet) {
  return {
    type: DASHBOARD_TABLE_SUMMARY_REQUEST,
    payload: { startDate, endDate, outlet },
  };
}
